import { useState } from 'react';
import styled from 'styled-components';
import Avatar, { Size } from 'src/components/avatar';
import { trackFootfallEvent } from 'src/utils/footfall';
import { Event, Section, Element } from 'src/constants/footfall';
import { useNextAndRelatedPosts } from 'src/modules/community/singlePost/components/nextPosts';
import Card from 'src/components/card';
import i18n from 'src/utils/translate';
import { titleSmall } from 'styles-js/mixins/typography';
import PostLink from 'src/modules/shared/links/postLink';
import Icon from 'src/components/icon';

const limit = 5;

export default function RelatedPosts(): JSX.Element {
  const [isExpanded, setIsExpanded] = useState(false);

  const { relatedPosts } = useNextAndRelatedPosts();

  const onClick = (postId: number) => {
    const postIds = relatedPosts.map(({ id }) => id);
    trackFootfallEvent(Event.CLICKED_RELATED_POST, { postId, postIds });
    trackFootfallEvent(Event.CLICKED, {
      clickType: 'post-side-bar',
      clickMetadata: {
        section: Section.PostsSideBar,
        element: Element.RelatedPost,
      },
    });
  };

  const onShowMoreClick = (e) => {
    e.preventDefault();
    if (!isExpanded) {
      trackFootfallEvent(Event.CLICKED, {
        clickType: 'post-side-bar',
        clickMetadata: {
          section: Section.PostsSideBar,
          element: Element.SeeMoreRelatedPosts,
        },
      });
    }
    setIsExpanded(!isExpanded);
  };

  if (relatedPosts.length === 0) return null;

  const editedCollection = isExpanded ? relatedPosts : relatedPosts.slice(0, limit);

  return (
    <Card title={i18n.t('Related Posts')}>
      <PostList>
        {editedCollection.map(({ id, postTypeId, urlEncodedTitle, group: { groupCode: communitySlug }, author, title }) => {
          return (
            <li key={id}>
              <PostLink
                communitySlug={communitySlug}
                postId={id}
                postTypeId={postTypeId}
                urlEncodedTitle={urlEncodedTitle}
                onClick={() => onClick(id)}
              >
                <Avatar name={author.username} size={Size.Small} url={author.avatar} />
                {title}
              </PostLink>
            </li>
          );
        })}
      </PostList>
      {relatedPosts.length > limit && (
        <div className="sidebar__show-more-btn">
          <a href="#" onClick={onShowMoreClick}>
            {isExpanded ? i18n.t('show less posts') : i18n.t('view more posts')}{' '}
            <Icon icon={isExpanded ? 'open-up' : 'open-down'} />
          </a>
        </div>
      )}
    </Card>
  );
}

const PostList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  li {
    margin-bottom: 15px;
    overflow: hidden;
    a {
      ${titleSmall}
      display: flex;
      gap: 10px;
      align-items: center;
    }
  }
`;
